// services/MeQrService.js

export default class MeQrService {
  static async generarQR({ nombreURL, token }) {
    const enlace = `https://smart-connect.laofi.work/${nombreURL}`;

    const payload = {
      qrFieldsData: {
        link: enlace
      },
      title: `SmartConnect_${nombreURL}`,
      format: "png",
      qrOptions: {
        size: 300,
        errorCorrectionLevel: "Q",
        pattern: "square",
        patternColor: "#000000",
        patternBackground: "#ffffff",
        cornetsOuter: "square",
        cornetsOuterColor: "#000000",
        cornetsInterior: "square",
        cornetsInteriorColor: "#000000",
        logotype: "https://firebasestorage.googleapis.com/v0/b/laofi-f175b.appspot.com/o/fotosPerfiles%2F51c578d3-177e-48c5-a712-ddbcd5863df4_Logo.png?alt=media&token=99ea3796-00ca-4021-81a8-8fb51207db27",
        logotypeSize: 0.4,
        logotypeMargin: 0.5,
        logotypeHideBackground: true,
        gradientPattern: null,
        gradientCornetsOuter: null,
        gradientCornetsInterior: null,
        gradientBackground: null
      },
      qrFrame: {
        name: "noFrame",
        color: "#000000",
        backgroundColor: "#ffffff",
        text: "",
        textSize: null,
        textColor: "#9C3AAF",
        textFont: "Roboto"
      }
    };

    const response = await fetch("https://me-qr.com/api/v2/qr/link/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": token
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`Error al generar QR: ${response.status}`);
    }

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  }
}
